import React from "react";
import "./ProductDetails.css";
import useFetchProductByName from "../../hooks/useFetchProjectByName";
import Loading from "../../Components/Loading/Loading";
import ProductSlider from "../../Components/Product/ProductSlider";
import ProductFooter from "../../Components/Product/Footer/ProductFooter";
import { Image } from "primereact/image";

function ProductDetails({ productName, prevProduct, nextProduct }) {
  const {
    product: selectedProduct,
    loading,
    error,
  } = useFetchProductByName(productName);
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <div className="error-container">Error: {error.message}</div>;
  }
  if (!selectedProduct || Object.keys(selectedProduct).length === 0) {
    return <div className="no-project-container">No project found!</div>;
  }
  return (
    <div className="productdetails-container">
      <div className="firstrow-section d-flex justify-content-between px-5">
        <h1>{selectedProduct.brand.name}</h1>
        <h1 className="secondproductdetail-productname">
          {selectedProduct.name}
        </h1>
      </div>
      <div className="secondrow-section d-flex justify-content-between items-center px-5">
        <p>{selectedProduct.breadCrumb}</p>
        <p>AVAILABLE FOR PRE-ORDER</p>
      </div>
      <div className="productimage-and-info-container d-flex">
        <div className="productmainimage col-sm-12 col-md-6 col-8">
          <Image
            src={
              process.env.REACT_APP_BACKEND_URL_IMAGES +
              selectedProduct.imageUrl
            }
            preview
            alt={selectedProduct.name}
          />
        </div>
        <div className="productinfo col-sm-12 col-md-6 col-4">
          <div className="productinfo-title">
            <h2>PRODUCT</h2>
            <h2 className="product-desc-title">DESCRPTION</h2>
          </div>
          <div className="listcontent-container-product">
            {selectedProduct.listContent &&
              selectedProduct.listContent.map((item, index) => (
                <div key={item.id} className="listcontent-item">
                  {index === 0 && (
                    <h2 className="more-info-title">MORE INFORMATION</h2>
                  )}
                  <div
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  ></div>
                </div>
              ))}
          </div>
          <div className="inquiry-button-container  mt-4">
            <a
              href={`mailto:info@medicdevices.com?subject=Inquiry for ${selectedProduct.name}`}
            >
              Send Inquiry
            </a>
          </div>
        </div>
        <div className="previousproductButton">
          <a href={prevProduct}>PREVIOUS</a>
        </div>
        <div className="nextproductButton">
          <a href={nextProduct}>NEXT</a>
        </div>
      </div>
      <ProductSlider images={selectedProduct.images} />
      <ProductFooter />
    </div>
  );
}

export default ProductDetails;
